import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { useIntlDateTimeFormat } from '@app/external/common/hooks/use-intl';
import { useSelector } from '../../../common/components/runtime-context';
import { getArchiveWidgetData } from '../../aggregated-archive/selectors';
import LinkList from '../link-list';
import LinkText from '../link-text';

const Archive = () => {
  const { t } = useTranslation();
  const { archive, error } = useSelector(getArchiveWidgetData);
  const longMonthYearFormatter = useIntlDateTimeFormat({ month: 'long', year: 'numeric' });

  const links = archive.map((archiveLink) => ({
    key: archiveLink.key,
    path: archiveLink.path,
    text: (
      <LinkText
        postCount={t('archive-link.post-count', { count: archiveLink.postCount })}
        a11yText={t('archive-link.a11y-post-count', { count: archiveLink.postCount })}
      >
        {longMonthYearFormatter.format(new Date(archiveLink.periodStart))}
      </LinkText>
    ),
  }));

  const emptyState =
    error === 429 ? t('archive-widget.too-many-requests') : t('empty-state.no-posts');

  return (
    <nav aria-label={t('aria-label.archive')}>
      <LinkList links={links} emptyState={emptyState} error={Boolean(error)} />
    </nav>
  );
};

export default Archive;
